import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu",
  "use": "icon-menu-usage",
  "viewBox": "0 0 33.749 33.749",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 33.749 33.749\" id=\"icon-menu\"><path d=\"M0 0h33.749v33.749H0z\" fill=\"none\" /><path d=\"M4.219 25.312h25.312v-2.813H4.219zm0-7.031h25.312v-2.813H4.219zm0-9.844v2.812h25.312V8.437z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol